export const isEmptyNumber = (number?: number | null) => {
	return number === null || number === undefined;
};
